import Login from '../auth/components/Login';
import Register from '../auth/components/Register';
import Submissions from './Submissions';
import Forgot from '../auth/components/Forgot';
import Restore from '../auth/components/Restore';

export default [
    {
        path: 'login',
        component: Login,
        name: 'front-login',
        meta: {
            auth: undefined, //This doesn't require login and doesn't redirect
        }
    },
    {
        path: 'register',
        name: 'front-register',
        component: Register,
        meta: {
            auth: undefined,
        }
    },
    {
        path: 'restore-password',
        name: 'front-restore',
        component: Restore,
        meta: {
            auth: undefined,
        }
    },
    {
        path: 'password-reminder',
        name: 'front-forgot',
        component: Forgot,
        meta: {
            auth: undefined,
        }
    },
    {
        path: 'account',
        name: 'front-account',
        component: Register
    },
    {
        path: 'my-submissions',
        name: 'front-submissions',
        component: Submissions
    }
]
